const Popover = require("bootstrap/js/dist/popover");
class Flyout {

    /**
     * Build Flyout Popover Instance
     */
    constructor() {
        this.clickedDismissButton = false;
        this.initializePopover();
    }

    /**
     * Initialize Flyout Popover Elements
     */
    initializePopover() {
        const flyouts = Array.from(document.querySelectorAll('[data-bs-toggle="flyout"]'));
        const mq = window.matchMedia("(min-width: 992px)");

        if (flyouts.length > 0) {
            flyouts.forEach(flyout => {
                const trigger = flyout.dataset.bsTrigger || 'hover click';
                const container = flyout.dataset.bsContainer || 'body';
                const placement = (flyout.dataset.bsPlacement && flyout.dataset.bsPlacement !== '')
                                  ? flyout.dataset.bsPlacement
                                  : (mq.matches ? 'right' : 'bottom');

                new Popover(flyout, {
                    delay: { show: 100, hide: 100 },
                    animation: true,
                    trigger: trigger,
                    html: true,
                    container: container,
                    placement
                });

                this.updateButton(flyout);
                this.handleFocus(flyout);
            });

            window.addEventListener('scroll', () => {
                flyouts.forEach(flyout => {
                    const popover = Popover.getInstance(flyout);
                    if (popover) {
                        popover.hide();
                    }
                });
            });
        }
    }

    /**
     * Update Button Content
     * @param flyout    {Object}
     */
    updateButton(flyout) {
        flyout.addEventListener('show.bs.popover', () => {
            const buttonClass = (flyout.dataset.btnType === 'text') ? `text-xs font-medium` : `btn btn-sm btn-primary`;
            const popover = Popover.getInstance(flyout);

            let btnElement = '';

            if (flyout.dataset.btnText) {
                if (flyout.dataset.btnUrl) {
                    btnElement = `<a href="${flyout.dataset.btnUrl}" class="flyout-popover-btn margin-top-small ${buttonClass}" target="_blank">${flyout.dataset.btnText}</a>`;
                } else if (flyout.dataset.btnAction) {
                    switch (flyout.dataset.btnAction) {
                        case 'dismiss':
                            btnElement = `<a class="flyout-popover-btn margin-top-small dismiss-flyout ${buttonClass}">{$flyout.dataset.btnText}</a>`;
                            break;
                    }
                }
            }

            let closeBtnElement = '';

            if (flyout.dataset.bsClose === 'true') {
                closeBtnElement = `<a class="close-btn dismiss-flyout" aria-hidden="false"><i class="fal fa-times"></i></a>`
            }

            const title = flyout.dataset.bsOriginalTitle ?? flyout.dataset.title;

            popover._config.template = `
                <div class="flyout-popover popover" role="tooltip">
                    <div class="popover-arrow"></div>
                    ${closeBtnElement}
                    ${(title) 
                      ? `<div class="h5 popover-title margin-top-zero">${title}</div>` 
                      : ''
                    }
                    <p class="popover-content margin-bottom-zero text-xs text-grey1">${flyout.dataset.bsContent}</p>
                    ${btnElement}
                </div>
            `;
        });
    }

    /**
     * Keep Popover open during hover and focus
     * @param flyout    {Object}
     */
    handleFocus(flyout) {
        const popover = Popover.getInstance(flyout);

        flyout.addEventListener('shown.bs.popover', (e) => {
            const eventTarget = e.target;
            const popoverElement = document.getElementById(eventTarget.getAttribute('aria-describedby')); // NOTE: 'aria-describedby' is a dynamic property added when popover gets shown
            popoverElement.addEventListener('mouseenter', mouseEnterCallback, { once: true });
        });

        flyout.addEventListener('hide.bs.popover', (e) => {
            const eventTarget = e.target;
            const popoverElement = document.getElementById(eventTarget.getAttribute('aria-describedby'));
            popoverElement.removeEventListener('mouseenter', mouseEnterCallback);
        });

        function fnNoop() {}
        function mouseEnterCallback() {
            const hideFn = popover.hide;
            popover.hide = fnNoop;
            this.addEventListener('mouseleave', () => {
                popover.hide = hideFn;
                popover.hide();
            }, { once: true });

            const closeButtons = this.querySelectorAll('.dismiss-flyout');

            if (closeButtons.length > 0) {
                closeButtons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        popover.hide = hideFn;
                        popover.hide();
                    });
                })

            }
        }
    }

    /**
     * Hide All Popovers
     */
    hideAll() {
        const flyouts = document.querySelectorAll('[data-bs-toggle="flyout"]');
        flyouts.forEach(flyout => {
            const popover = Popover.getInstance(flyout);
            popover?.hide();
        });
    }
}

module.exports = Flyout;
